export const newFeatures = {
    collection: {
        level: '等级',
        fix_time: '修复次数：',
        earn_exercise: '每次运动收益：',
        on_selling: '正在销售',
        sell: '出售',
        edit: '编辑',
        buy: '购买',
        stop: '停止',
        cancel: '取消',
        update: '更新',
        search: '搜索',
    },
    sort_filter: {
        sort_by: '排序方式',
        filter: '筛选',
        status: '状态',
        sell_in: '出售中',
        class: '分类',
        sale_hight: '最近销售',
        sale_low: '由旧至新',
        level_hight: '等级：高到低',
        level_low: '等级：低到高',
        reward_hight: '奖励：高到低',
        reward_low: '奖励：低到高',
        fix_time_hight: '修复次数：高到低',
        fix_time_low: '修复次数：低到高',
        radio_1: '准备赚取额外收入',
        radio_2: '需要立即修复',
        radio_3: '正在销售',
        clear_all: '清除所有',
    },
    modal_sell: {
        fee: '如果出售订单成功，您将获得价值的 %{fee}（约 %{value}）。',
        sell_nft: '出售 NFT',
        edit_nft: '编辑 NFT',
        buy_Nft: '购买 NFT',
        stop_sell: '停止销售',
        want_sell_in: '我想卖',
        want_buy: '您想购买此 NFT 吗',
        want_stop: '您想停止销售吗',
        code_2fa: '2FA 验证码',
    },
    tab_leaf: {
        payment: '支付',
        total_amount: '总金额',
        quantity: '数量',
        pay: '支付',
        balance: '余额',
        limitMessage: '当前余额不足!',
        you_have: '您有：',
        leaf: ' 个叶子',
    },
    transaction: {
        transaction_history: '交易历史记录',
        type: '类型',
        item_id: '物品编号',
        tier: '秩',
        level: '等级',
        price: '价格',
        token: '代币',
        seller_buyer: '卖家/买家',
        time: '时间',
        filter: '过滤器',
        send: '发送 ',
    },
    common: {
        price: '价格',
        noData_market: '没有与您的搜索相匹配的 NFT.',
        edit: '编辑',
        no_transaction: '您没有任何交易.',
        all: '全部',
        buy: '购买',
        sell: '出售',
        sent: '发送',
        receive: '接收',
        connect: '连接',
        amount: '量',
        leaves: '叶子',



    },
    tab_ticket: {
        ticket: ' 票'
    },
};
